import React from "react"
import {
    Box,
    Typography,
    IconButton,
    Checkbox,
    FormControlLabel,
    Radio,
    RadioGroup,
    useTheme,
} from "@mui/material"
import { Close } from "@mui/icons-material"
import { useSelector } from "react-redux"
import { foodItemType, typeIcons } from "utils/constant"
import CustomTypography from "components/Fileds/CustomTypography"
import { formatCurrency } from "utils/function"

const AddOnsContent = ({
    item,
    onClose,
    selectedAddOnIds = [],
    handleToggle,
    viewOnly = false,
    children
}) => {
    const theme = useTheme();
    const userData = useSelector((state) => state?.posData)

    if (!item) return null

    return (
        <Box className='close-icon-contianer'>
            <IconButton onClick={onClose} className="close-icon">
                <Close />
            </IconButton>

            <Box className='d-flex' sx={{ p: "10px", pb: 0 }}>
                <Box className='food-item-logo-container' sx={{ position: "relative" }}>
                    <img
                        src={`${process.env.REACT_APP_API_ROUTE}/files/${item?.image}` || "/placeholder.svg"}
                        alt={'logo'}
                        className="food-item-logo"
                    />

                    {item.type && (
                        <Box className='d-flex align-items-center'
                            sx={{
                                position: "absolute",
                                top: 5,
                                left: 5,
                                // backgroundColor: "#fff",
                                borderRadius: "4px",
                                padding: "2px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}>
                            {/* <Box sx={{ mr: 0, position: "relative" }}> */}
                            <img
                                src={typeIcons[item.type] || typeIcons.veg}
                                alt={'logo'}
                                className="food-item-type-logo"
                            />
                            {/* </Box> */}
                            {/* <Box className="food-item-type-text"
                                component="span"
                                sx={{ color: theme.palette.drawermenuitem.main, textTransform: 'uppercase' }}
                            >
                                {foodItemType.find(t => t.value === item.type)?.name || item.type}
                            </Box> */}
                        </Box>
                    )}

                </Box>
                <Box>
                    <CustomTypography
                        variant={"caption"}
                        label={"Add-Ons for"}
                        sx={{
                            mb: 0, fontSize: '14px', fontWeight: 300,
                            color: theme.palette.typographyLabel.main
                        }}
                    />
                    <CustomTypography
                        label={item.name}
                        variant={"h6"}
                        sx={{
                            marginTop: '-6px', fontSize: '24px', fontWeight: 700,
                            color: theme.palette.typographyLabel.main,
                            mb: 0, lineHeight: 1.2
                        }}
                    />


                </Box>
            </Box>

            {/* Dynamically render each group of add-ons */}
            {item.groups.map((group) => {
                // compute selected value for this group (if any)
                const selectedForGroup = selectedAddOnIds.find((id) =>
                    group.add_ons.some((ao) => ao.id === id)
                )
                return (
                    <Box key={group.id} sx={{ p: "10px", pb: 0 }}>
                        <Typography variant="subtitle1" fontWeight="bold" >
                            {group.name}
                        </Typography>

                        {group?.group_type === 'single' ? (
                            <RadioGroup
                                value={selectedForGroup ? selectedForGroup.toString() : ''}
                                onChange={(e) => !viewOnly && handleToggle(parseInt(e.target.value, 10), true, group?.add_ons?.map(a => a.id))}
                            >
                                {group.add_ons.map((ao) => (
                                    <FormControlLabel
                                        key={ao.id}
                                        value={ao.id.toString()}
                                        control={<Radio
                                            disabled={viewOnly}
                                            sx={{
                                                color: 'black',
                                                padding: '4.5px',
                                                '&.Mui-checked': { color: 'black' }
                                            }}
                                        />}
                                        label={
                                            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: 'flex-start', gap: 1 }}>
                                                <Box sx={{ flex: 1 }}>
                                                    <Typography component="span" sx={{ fontSize: '16px', fontWeight: 500, color: 'black' }}>{ao.name}</Typography>
                                                    {ao?.notes && (
                                                        <Typography component="span" variant="body2" sx={{ fontSize: '14px', fontWeight: 300, color: 'text.secondary', ml: 0.5 }}>
                                                            {`(${ao?.notes})`}
                                                        </Typography>
                                                    )}
                                                </Box>

                                                <Typography color="success.main" sx={{ whiteSpace: 'nowrap', fontWeight: 500 }}>
                                                    + {formatCurrency(ao.price.toFixed(2), userData?.vendor?.currency)}
                                                </Typography>
                                            </Box>
                                        }
                                        sx={{
                                            width: "100%",
                                            m: 0,
                                            mb: 0.5,
                                            display: 'flex',
                                            '& .MuiFormControlLabel-label': { flexGrow: 1, width: '100%' }
                                        }}
                                    />
                                ))}
                            </RadioGroup>
                        ) : (
                            group.add_ons.map((ao) => (
                                <FormControlLabel
                                    key={ao.id}
                                    control={
                                        <Checkbox
                                            checked={selectedAddOnIds.includes(ao.id)}
                                            onChange={() => !viewOnly && handleToggle(ao.id)}
                                            disabled={viewOnly}
                                            sx={{
                                                color: 'black',
                                                padding: '4.5px',
                                                '&.Mui-checked': { color: 'black' }
                                            }}
                                        />
                                    }
                                    label={
                                        <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: 'flex-start', gap: 1 }}>
                                            <Box sx={{ flex: 1 }}>
                                                <Typography component="span" sx={{ fontSize: '16px', fontWeight: 500, color: 'black' }}>{ao.name}</Typography>
                                                {ao?.notes && (
                                                    <Typography component="span" variant="body2" sx={{ fontSize: '14px', fontWeight: 300, color: 'text.secondary', ml: 0.5 }}>
                                                        {`(${ao?.notes})`}
                                                    </Typography>
                                                )}
                                            </Box>
                                            <Typography color="success.main" sx={{ whiteSpace: 'nowrap', fontWeight: 500 }}>
                                                + {formatCurrency(ao.price.toFixed(2), userData?.vendor?.currency)}
                                            </Typography>
                                        </Box>
                                    }
                                    sx={{
                                        width: "100%",
                                        m: 0,
                                        mb: 0.5,
                                        display: 'flex',
                                        '& .MuiFormControlLabel-label': { flexGrow: 1, width: '100%' }
                                    }}
                                />
                            ))
                        )}
                    </Box>
                )
            })}

            {!viewOnly && children}
        </Box>
    )
}

export default AddOnsContent
